import React, { useState } from 'react';
import '../styles/Contact.css';
import contactIllustration from '../assets/contact-illustration.png';
import ContactUs from './Form/ContactUs';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import logoMarker from '../assets/ReansConsultingLogo.png';
import { Modal } from 'react-bootstrap';

// Custom marker icon
const reansIcon = new L.Icon({
  iconUrl: logoMarker,
  iconSize: [120, 48],
  iconAnchor: [24, 48],
  popupAnchor: [0, -40],
  className: 'leaflet-logo-marker',
});

export default function Contact() {
  const [showMapModal, setShowMapModal] = useState(false);
  const handleOpen = () => setShowMapModal(true);
  const handleClose = () => setShowMapModal(false);

  const malaysiaCoordinates = [3.2843301, 101.4732208];

  return (
    <div className="contact-page container py-5">
      <div className="row align-items-center g-5">
        {/* Left Illustration */}
        <div className="col-lg-5 col-12 text-center">
          <img
            src={contactIllustration}
            alt="Contact Illustration"
            className="img-fluid rounded shadow-sm mb-4"
          />
        </div>

        {/* Right Content */}
        <div className="col-lg-7">
          <h1>Let’s Get in Touch</h1>
          <p className="mb-4 text-muted">
            Whether you're looking for advice, solutions, or collaboration—our team is ready to help.
          </p>

          <div className="row">
            {/* Contact Form */}
            <div className="col-md-7">
              <ContactUs />
            </div>

            {/* Contact Info */}
            <div className="col-md-5 mt-4 mt-md-0 text-center text-md-start">
            <h4 className="fw-semibold mb-3">Location Map</h4>
              <div className="map-container mb-3" onClick={handleOpen}>
                <MapContainer
                  center={malaysiaCoordinates}
                  zoom={2}
                  scrollWheelZoom={false}
                  dragging={false}
                  doubleClickZoom={false}
                  zoomControl={false}
                  attributionControl={false}
                  className="leaflet-map"
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  <Marker position={malaysiaCoordinates} icon={reansIcon} />
                </MapContainer>
              </div>

              <h4 className="fw-semibold mb-3">Contact Details</h4>
              <ul className="list-unstyled contact-info">
                <li className="mb-3">
                  <i className="bi bi-geo-alt text-danger me-2"></i>
                  56-1-A, Jalan 7A/2,<br />
                  Bandar Tasik Puteri, Rawang, Selangor
                </li>
                <li className="mb-3">
                  <i className="bi bi-envelop text-primary me-2"></i>
                  <a href="mailto:norehan@reansconsult.com">norehan@reansconsult.com</a>
                </li>
                <li className="mb-3">
                  <i className="bi bi-telephone text-success me-2"></i>
                  <a href="tel:+60126877057">+6012 687 7057</a>
                </li>
                <li>
                  <i className="bi bi-globe text-info me-2"></i>
                  <a href="https://www.reansconsult.com" target="_blank" rel="noopener noreferrer">
                    www.reansconsult.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Map Modal */}
      <Modal show={showMapModal} onHide={handleClose} centered size="xl">
        <Modal.Body className="p-0">
          <div className="modal-map-container">
            <MapContainer
              center={malaysiaCoordinates}
              zoom={17}
              scrollWheelZoom={true}
              className="leaflet-modal-map"
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              <Marker position={malaysiaCoordinates} icon={reansIcon} />
            </MapContainer>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
